module.exports = __webpack_public_path__ + "img/face-frown.98056f00.svg";